import { gql } from '@apollo/client'

export const UPLOAD_PROFILE_PICTURE = gql`
  mutation UploadProfilePicture($imageBase64: String!, $contentType: String!) {
    uploadProfilePicture(input: { imageBase64: $imageBase64, contentType: $contentType }) {
      userAccount {
        id
        picture
      }
      errors
    }
  }
`

export const DELETE_PROFILE_PICTURE = gql`
  mutation DeleteProfilePicture {
    deleteProfilePicture(input: {}) {
      userAccount {
        id
        picture
      }
      errors
    }
  }
`
